import * as Yup from 'yup';

const slugSchema = Yup.string()
  .trim()
  .required('Informe o slug do checklist')
  .matches(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, {
    message: 'O slug deve conter apenas letras minúsculas, números e hífens',
  });

export class CreateChecklistTemplateValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().required('Informe o nome do checklist'),
      google_id: Yup.string().required('Informe o ID ou URL do Google Forms'),
      slug: slugSchema,
    });
  }
}

export class UpdateChecklistTemplateValidator {
  public get schema() {
    return Yup.object().shape({
      name: Yup.string().required('Informe o nome do checklist'),
      google_id: Yup.string().required('Informe o ID ou URL do Google Forms'),
      slug: slugSchema,
    });
  }
}
